import _tokens from './tokens.js'
import { extractUnits } from './utils.js'

import { UnitType } from '@exodus/currency'

const name = 'theta'
const displayName = 'Theta'
const ticker = 'THETA'
const displayTicker = 'THETA'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const feeAssetName = 'tfuel'
const primaryColor = '#17E4B9'
const gradientColors = ['#17E4B9', '#12B2E6']
const gradientCoords = { x1: '7.266%', y1: '24.014%', x2: '91.47%', y2: '77.393%' }
const chainBadgeColors = gradientColors

const units = {
  thetawei: 0,
  THETA: 18,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.thetatoken.org/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://explorer.thetatoken.org/txs/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Theta mainnet operates as a decentralized network in which users share bandwidth and computing resources on a peer-to-peer (P2P) basis for video-streaming.',
  reddit: 'https://www.reddit.com/r/theta_network/',
  twitter: 'https://twitter.com/Theta_Network',
  website: 'https://www.thetatoken.org/',
  telegram: 'https://t.me/thetanetwork',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  feeAssetName,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export const tokens = _tokens.map((token) => {
  const units = extractUnits(token)
  return {
    ...token,
    // name,
    // displayName,
    // decimals | units,
    // ticker,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    assetType: 'THETA_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    currency: UnitType.create(units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    feeAssetName,
    info: token.info || {},
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    toString: () => token.name,
    units,
  }
})

export default [asset, ...tokens]
